import { RefreshCw } from "lucide-react";

/**
 * LoadingSpinner — consistent page-level loader. Used by Suspense fallback
 * and manual loading states.
 */
export default function LoadingSpinner({ label = "Loading..." }) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-3 text-gray-400">
      <RefreshCw size={32} className="animate-spin opacity-50" />
      <p className="text-sm">{label}</p>
    </div>
  );
}
